import { Color } from '@diritto/common/style/color';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

interface VerticalLineProps {
  className?: string;
  color?: string;
  height?: number;
}

export const VerticalLine = ({ className, color, height }: VerticalLineProps) => (
  <StyledVerticalLine className={className} color={color} height={height} />
);

const StyledVerticalLine = styled.div(
  ({ color = Color.Gray300, height = 16 }: VerticalLineProps) => css`
    width: 1px;
    height: ${height}px;
    background-color: ${color};
  `,
);
